import { Button } from '@heidi/design-system/button';
import { LinkedinIcon } from '@heidi/design-system/icons';
import { ExternalLink } from '@heidi/snowflake-ui/external-link';
import { Link, Mail } from 'lucide-react';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { communityTemplateDetailsMessages } from '../../communityTemplateDetails.messages';

interface ShareActionsProps {
  getUrlWithoutHash: () => string;
  onCopyLinkClick: () => void;
}

export const ShareActions = ({
  getUrlWithoutHash,
  onCopyLinkClick,
}: ShareActionsProps) => {
  const intl = useIntl();

  const shareUrl = useMemo(() => getUrlWithoutHash(), [getUrlWithoutHash]);

  const mailToHref = useMemo(
    () =>
      `mailto:?subject=${encodeURIComponent(
        intl.formatMessage(communityTemplateDetailsMessages.emailShareSubject)
      )}&body=${encodeURIComponent(
        intl.formatMessage(communityTemplateDetailsMessages.emailShareBody)
      )}\n\n${shareUrl}`,
    [intl, shareUrl]
  );

  return (
    <div className="flex gap-2">
      <Button
        size="sm"
        variant="outline"
        iconOnly
        aria-label={intl.formatMessage({ defaultMessage: 'Copy link', id: 'lbr3Lq2Lnm' })}
        onClick={onCopyLinkClick}
      >
        <Link />
      </Button>

      <ExternalLink
        target="_blank"
        href={`https://www.linkedin.com/sharing/share-offsite/?url=${shareUrl}`}
      >
        <Button
          size="sm"
          variant="outline"
          iconOnly
          aria-label={intl.formatMessage({
            defaultMessage: 'Share on LinkedIn',
            id: 'M4kFT5MCLI',
          })}
        >
          <LinkedinIcon />
        </Button>
      </ExternalLink>

      <ExternalLink target="_blank" href={mailToHref}>
        <Button
          size="sm"
          variant="outline"
          iconOnly
          aria-label={intl.formatMessage({
            defaultMessage: 'Share via email',
            id: 'swOBKPaHjz',
          })}
        >
          <Mail />
        </Button>
      </ExternalLink>
    </div>
  );
};
